import { LocationTypes } from "../ActionTypes/LocationTypes"

let initialState = {
    ActiveLocations : [],
    ActiveLocationsPagination : null

}

const LocationReducer = (state = initialState , action) => {

        switch(action.type){

            case LocationTypes.GET_ACTIVE_LOCATIONS:
                    let ActiveLocations_Copy = [];
                    ActiveLocations_Copy = [
                        ...state.ActiveLocations,
                        ...action.payload.data,
                    ];
                    state = {
                        ...state,
                        ActiveLocationsPagination: action.payload,
                        ActiveLocations: ActiveLocations_Copy
                    };
                    break;

            case LocationTypes.CLEAR_ACTIVE_LOCATIONS:
                    state = {
                        ActiveLocationsPagination: null,
                        ActiveLocations: []
                    };
                    break;
                }
        return state ;
}

export default LocationReducer;
